import { IconButton } from "@hcsc-fiber/react";
import React, { useContext } from "react";
import { StateContext } from "../../context/stateContext";
import { translations } from "../../translate";
import styles from "./BackChevronWithTitle.module.scss";

export type backChavronType = {
  text?: string;
  onClick?: () => void;
  children?: never;
};
const BackChevronWithTitle: React.FC<backChavronType> = ({ text, onClick, children }): JSX.Element => {
  const { languageCode } = useContext(StateContext);
  return (
    <div className={styles.container}>
      <div className={styles.backButtonWithText} onClick={onClick}>
        <IconButton name="chevron-left" color="gray-4" size={4}>
          {translations.backLabel[languageCode]}
        </IconButton>
        <span className={styles.backText}> {translations.backLabel[languageCode]}</span>
      </div>
      <h3 className={styles.heading}>{children ? children : text}</h3>
    </div>
  );
};

export default BackChevronWithTitle;
